var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 8-5-5L14.3.7c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4L17 8zM7.3 16.3l-3.6-3.6c-.4-.4-.4-1 0-1.4l6.6-6.6c.4-.4 1-.4 1.4 0l3.6 3.6c.4.4.4 1 0 1.4l-6.6 6.6c-.4.4-1 .4-1.4 0zM2 15l-1 4 4-1-3-3z"
  })));
};
export default SvgPencil;